import { Component, input } from '@angular/core';

@Component({
  selector: 'app-product-box',
  imports: [],
  templateUrl: './product-box.html',
  styleUrl: './product-box.scss',
})
export class ProductBox {

  box = input<any>()
  type = input<string>('')

}
